import { motion, AnimatePresence } from "framer-motion";
import { HERO_SLIDES, WA_GENERAL } from "../lib/site";

const Stamp = () => (
  <a href={WA_GENERAL} target="_blank" rel="noopener noreferrer" data-testid="hero-stamp-whatsapp"
    className="absolute -left-3 -bottom-10 sm:-left-12 z-20 grid h-28 w-28 sm:h-32 sm:w-32 place-items-center rounded-full bg-ink text-white shadow-2xl transition-transform duration-500 hover:scale-110">
    <svg viewBox="0 0 100 100" className="absolute inset-0 h-full w-full animate-spin-slow">
      <defs><path id="circ" d="M50,50 m-37,0 a37,37 0 1,1 74,0 a37,37 0 1,1 -74,0" /></defs>
      <text className="fill-white font-mono" fontSize="8.6" letterSpacing="2.4">
        <textPath href="#circ">CHAT · PLAN · GO · BOOK ON WHATSAPP ·</textPath>
      </text>
    </svg>
    <span className="font-display text-2xl font-extrabold text-go">GO</span>
  </a>
);

export const HeroFrame = ({ idx, setIdx, rotX, rotY, imgY }) => {
  const slide = HERO_SLIDES[idx];
  return (
    <motion.div style={{ rotateX: rotX, rotateY: rotY, transformStyle: "preserve-3d" }}
      className="relative mx-auto w-full max-w-[400px] sm:max-w-[460px]">
      <motion.div initial={{ clipPath: "inset(14% 14% 14% 14% round 200px 200px 32px 32px)", scale: 0.94 }}
        animate={{ clipPath: "inset(0% 0% 0% 0% round 220px 220px 32px 32px)", scale: 1 }}
        transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1], delay: 0.3 }}
        className="relative aspect-[4/5] overflow-hidden rounded-t-[220px] rounded-b-[32px] bg-ink" data-testid="hero-carousel">
        <AnimatePresence initial={false}>
          <motion.img key={slide.img} src={slide.img} alt={slide.label}
            initial={{ opacity: 0, scale: 1.15 }} animate={{ opacity: 1, scale: 1.05 }} exit={{ opacity: 0 }}
            transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
            style={{ y: imgY }} className="absolute inset-0 h-[115%] w-full object-cover" />
        </AnimatePresence>
        <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-go/20 mix-blend-multiply" />
        <div className="absolute bottom-5 left-24 sm:left-24 right-5 flex items-end justify-between text-white">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-white/80">Now showing</p>
            <p className="font-display text-3xl font-extrabold" data-testid="hero-slide-label">{slide.label}</p>
          </div>
          <div className="flex gap-1.5">
            {HERO_SLIDES.map((s, i) => (
              <button key={s.code} onClick={() => setIdx(i)} aria-label={`Show ${s.label}`} data-testid={`hero-dot-${i}`}
                className={`h-1.5 rounded-full transition-[width,background-color] duration-500 ${i === idx ? "w-8 bg-go" : "w-3 bg-white/60"}`} />
            ))}
          </div>
        </div>
      </motion.div>
      <div style={{ transform: "translateZ(60px)" }}
        className="absolute -right-3 top-16 sm:-right-8 z-20 rounded-2xl bg-white px-4 py-3 shadow-2xl ticket-edge">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-600">Boarding · BOM</p>
        <p className="font-display text-xl font-extrabold text-ink">BOM <span className="text-go">→</span> {slide.code}</p>
      </div>
      <div style={{ transform: "translateZ(80px)" }}><Stamp /></div>
    </motion.div>
  );
};
